import React from 'react';
export function Header() {
  return <header className="bg-[#0a0e1a]/95 backdrop-blur-sm py-4 px-5 md:px-8 sticky top-0 z-50 border-b border-[#1a1f3a] shadow-lg" data-id="element-49">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0" data-id="element-50">
        <div className="text-white font-serif font-bold text-xl md:text-2xl tracking-wide text-center md:text-left" data-id="element-51">
          PROTOCOLO SILENCIO 11PM
        </div>
        <a href="#comprar" className="bg-[#d4a853] hover:bg-[#e5b964] text-[#0a0e1a] font-bold px-6 py-2.5 rounded transition-all duration-300 shadow-[0_0_15px_rgba(212,168,83,0.3)] text-sm md:text-base transform hover:scale-105 active:scale-95 flex items-center justify-center w-full md:w-auto" data-id="element-52">
          Ver Protocolo
        </a>
      </div>
    </header>;
}